import gql from "graphql-tag";
import {responseField} from "../../../../base.graphql";

export const districtGqlFields = `
id
uniqueId
name
code
`;


export const ALL_DISTRICTS_BY_REGION = gql`
query GetAllDistrict($regionUniqueId: String) {
  getAllDistrict(regionUniqueId: $regionUniqueId) {
      response {
        ${responseField}
      }
      data {
        ${districtGqlFields}
      }
    }
  }
`
